import React from 'react';
import { StickyBar } from './components/StickyBar';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { ProblemaSection } from './components/ProblemaSection';
import { ParadigmaSection } from './components/ParadigmaSection';
import { SolucionSection } from './components/SolucionSection';
import { IncluyeSection } from './components/IncluyeSection';
import { ComoFuncionaSection } from './components/ComoFuncionaSection';
import { ResultadoSection } from './components/ResultadoSection';
import { PrecioSection } from './components/PrecioSection';
import { GarantiaSection } from './components/GarantiaSection';
import { TestimoniosSection } from './components/TestimoniosSection';
import { CTAFinalSection } from './components/CTAFinalSection';
import { Footer } from './components/Footer';
import { WhatsAppButton } from './components/WhatsAppButton';
export function App() {
  return <div className="min-h-screen bg-white font-sans text-brand-black selection:bg-brand-orange selection:text-brand-black" data-id="element-0">
      <StickyBar data-id="element-1" />
      <Navbar data-id="element-2" />

      <main data-id="element-3">
        <HeroSection data-id="element-4" />
        <ProblemaSection data-id="element-5" />
        <ParadigmaSection data-id="element-6" />
        <SolucionSection data-id="element-7" />
        <IncluyeSection data-id="element-8" />
        <ComoFuncionaSection data-id="element-9" />
        <ResultadoSection data-id="element-10" />
        <PrecioSection data-id="element-11" />
        <GarantiaSection data-id="element-12" />
        <TestimoniosSection data-id="element-13" />
        <CTAFinalSection data-id="element-14" />
      </main>

      <Footer data-id="element-15" />
      <WhatsAppButton data-id="element-16" />
    </div>;
}